export enum ButtonType {
  GREEN = 'green',
  BLACK = 'black',
  WHITE = 'white',
}
